import { defineStore } from 'pinia'

export const useCartStore = defineStore('cart', {
  state: () => ({
    vendor: null,
    events: [],
    selectedEvent: null,
    // Products data from catalog API
    products: [],
    byLocation: {},
    locationsMeta: [],  // Full location metadata from event
    // Selected offering and configuration
    selectedOffering: null,
    selectedOptionId: null,
    selectedDates: [],
    selectedLocation: null,
    quantity: 1,
    // Current order
    order: null,
    commSettings: {},
    // Preview mode (accessed via preview token)
    isPreviewMode: false,
  }),

  getters: {
    hasSelectedEvent(state) {
      return Boolean(state.selectedEvent)
    },

    hasSelectedOffering(state) {
      return Boolean(state.selectedOffering)
    },

    hasOrder(state) {
      return Boolean(state.order)
    },

    locations(state) {
      return Object.keys(state.byLocation)
    },

    selectedProduct(state) {
      return state.selectedOffering?.product || null
    },
  },

  actions: {
    setVendor(vendor) {
      this.vendor = vendor || null
    },

    setEvents(events) {
      this.events = Array.isArray(events) ? events : []
    },

    setSelectedEvent(event) {
      this.selectedEvent = event || null
    },

    setProducts(data) {
      this.products = data.products || []
      this.byLocation = data.byLocation || {}
      this.locationsMeta = data.locations || []
      // Comm settings come from the catalog API alongside products
      if (data.commSettings) {
        this.commSettings = data.commSettings
      }
    },

    setSelectedOffering(offering) {
      this.selectedOffering = offering || null
      // Reset option when offering changes
      this.selectedOptionId = null
    },

    setSelectedOptionId(id) {
      this.selectedOptionId = id
    },

    setSelectedDates(dates) {
      this.selectedDates = Array.isArray(dates) ? dates : []
    },

    setQuantity(qty) {
      this.quantity = qty > 0 ? qty : 1
    },

    setSelectedLocation(location) {
      this.selectedLocation = location || null
    },

    setCommSettings(settings) {
      this.commSettings = settings || {}
    },

    setOrder(order) {
      this.order = order || null
    },

    setPreviewMode(isPreview) {
      this.isPreviewMode = Boolean(isPreview)
    },

    clearSelection() {
      this.selectedOffering = null
      this.selectedOptionId = null
      this.selectedDates = []
      this.selectedLocation = null
      this.quantity = 1
    },

    clear() {
      this.vendor = null
      this.events = []
      this.selectedEvent = null
      this.products = []
      this.byLocation = {}
      this.locationsMeta = []
      this.selectedOffering = null
      this.selectedOptionId = null
      this.selectedDates = []
      this.selectedLocation = null
      this.quantity = 1
      this.order = null
      this.commSettings = {}
      this.isPreviewMode = false
    },
  },
})
